export type Environment = 'local' | 'ai-local' | 'dev' | 'preprod' | 'production' | 'ai-dev' | 'ai-prod';

export const getEnvironment = (): Environment => {
  if (typeof window === 'undefined') {
    let environment: Environment;
    if (process.argv.indexOf('--local') > -1) {
      environment = 'local';
    } else if (process.argv.indexOf('--dev') > -1) {
      environment = 'dev';
    } else if (process.argv.indexOf('--preprod') > -1) {
      environment = 'preprod';
    } else {
      environment = 'production';
    }

    return environment;
  }

  const { origin } = window.location;

  if (origin.includes('localhost')) {
    // return 'ai-local';
    return 'local';
  }

  if (origin.includes('web-dev-ai')) {
    return 'ai-dev';
  }

  if (origin.includes('web-dev')) {
    return 'dev';
  }

  if (origin.includes('pre-prod')) {
    return 'preprod';
  }

  if (origin.includes('ai.')) {
    return 'ai-prod';
  }

  return 'production';
};
